document.addEventListener("DOMContentLoaded", function () {

  var COUNTRY_CURRENCY = {
    AF: { code: 'AFN', symbol: '؋' },
    AL: { code: 'ALL', symbol: 'L' },
    AM: { code: 'AMD', symbol: '֏' },
    AO: { code: 'AOA', symbol: 'Kz' },
    AR: { code: 'ARS', symbol: '$' },
    AU: { code: 'AUD', symbol: 'A$' },
    AZ: { code: 'AZN', symbol: '₼' },
    BA: { code: 'BAM', symbol: 'KM' },
    BD: { code: 'BDT', symbol: '৳' },
    BG: { code: 'BGN', symbol: 'лв' },
    BH: { code: 'BHD', symbol: 'BD' },
    BO: { code: 'BOB', symbol: 'Bs.' },
    BR: { code: 'BRL', symbol: 'R$' },
    BY: { code: 'BYN', symbol: 'Br' },
    CA: { code: 'CAD', symbol: 'CA$' },
    CH: { code: 'CHF', symbol: 'Fr' },
    CL: { code: 'CLP', symbol: '$' },
    CN: { code: 'CNY', symbol: '¥' },
    CO: { code: 'COP', symbol: '$' },
    CR: { code: 'CRC', symbol: '₡' },
    CZ: { code: 'CZK', symbol: 'Kč' },
    DK: { code: 'DKK', symbol: 'kr' },
    DO: { code: 'DOP', symbol: 'RD$' },
    DZ: { code: 'DZD', symbol: 'DA' },
    EG: { code: 'EGP', symbol: 'E£' },
    AT: { code: 'EUR', symbol: '€' },
    BE: { code: 'EUR', symbol: '€' },
    CY: { code: 'EUR', symbol: '€' },
    DE: { code: 'EUR', symbol: '€' },
    EE: { code: 'EUR', symbol: '€' },
    ES: { code: 'EUR', symbol: '€' },
    FI: { code: 'EUR', symbol: '€' },
    FR: { code: 'EUR', symbol: '€' },
    GR: { code: 'EUR', symbol: '€' },
    HR: { code: 'EUR', symbol: '€' },
    IE: { code: 'EUR', symbol: '€' },
    IT: { code: 'EUR', symbol: '€' },
    LT: { code: 'EUR', symbol: '€' },
    LU: { code: 'EUR', symbol: '€' },
    LV: { code: 'EUR', symbol: '€' },
    ME: { code: 'EUR', symbol: '€' },
    MT: { code: 'EUR', symbol: '€' },
    NL: { code: 'EUR', symbol: '€' },
    PT: { code: 'EUR', symbol: '€' },
    SI: { code: 'EUR', symbol: '€' },
    SK: { code: 'EUR', symbol: '€' },
    GB: { code: 'GBP', symbol: '£' },
    GE: { code: 'GEL', symbol: '₾' },
    GH: { code: 'GHS', symbol: '₵' },
    GT: { code: 'GTQ', symbol: 'Q' },
    HK: { code: 'HKD', symbol: 'HK$' },
    HN: { code: 'HNL', symbol: 'L' },
    HU: { code: 'HUF', symbol: 'Ft' },
    ID: { code: 'IDR', symbol: 'Rp' },
    IL: { code: 'ILS', symbol: '₪' },
    IN: { code: 'INR', symbol: '₹' },
    IQ: { code: 'IQD', symbol: 'IQD' },
    IS: { code: 'ISK', symbol: 'kr' },
    JM: { code: 'JMD', symbol: 'J$' },
    JO: { code: 'JOD', symbol: 'JD' },
    JP: { code: 'JPY', symbol: '¥' },
    KE: { code: 'KES', symbol: 'KSh' },
    KG: { code: 'KGS', symbol: 'с' },
    KH: { code: 'KHR', symbol: '៛' },
    KR: { code: 'KRW', symbol: '₩' },
    KW: { code: 'KWD', symbol: 'KD' },
    KZ: { code: 'KZT', symbol: '₸' },
    LB: { code: 'LBP', symbol: 'LL' },
    LK: { code: 'LKR', symbol: 'Rs' },
    MA: { code: 'MAD', symbol: 'MAD' },
    MD: { code: 'MDL', symbol: 'L' },
    MK: { code: 'MKD', symbol: 'ден' },
    MM: { code: 'MMK', symbol: 'K' },
    MN: { code: 'MNT', symbol: '₮' },
    MX: { code: 'MXN', symbol: 'MX$' },
    MY: { code: 'MYR', symbol: 'RM' },
    NG: { code: 'NGN', symbol: '₦' },
    NO: { code: 'NOK', symbol: 'kr' },
    NP: { code: 'NPR', symbol: 'Rs' },
    NZ: { code: 'NZD', symbol: 'NZ$' },
    OM: { code: 'OMR', symbol: 'OMR' },
    PA: { code: 'PAB', symbol: 'B/.' },
    PE: { code: 'PEN', symbol: 'S/.' },
    PH: { code: 'PHP', symbol: '₱' },
    PK: { code: 'PKR', symbol: 'Rs' },
    PL: { code: 'PLN', symbol: 'zł' },
    PY: { code: 'PYG', symbol: '₲' },
    QA: { code: 'QAR', symbol: 'QR' },
    RO: { code: 'RON', symbol: 'lei' },
    RS: { code: 'RSD', symbol: 'din' },
    RU: { code: 'RUB', symbol: '₽' },
    SA: { code: 'SAR', symbol: 'SR' },
    SE: { code: 'SEK', symbol: 'kr' },
    SG: { code: 'SGD', symbol: 'S$' },
    TH: { code: 'THB', symbol: '฿' },
    TJ: { code: 'TJS', symbol: 'SM' },
    TN: { code: 'TND', symbol: 'TND' },
    TR: { code: 'TRY', symbol: '₺' },
    TT: { code: 'TTD', symbol: 'TT$' },
    TW: { code: 'TWD', symbol: 'NT$' },
    TZ: { code: 'TZS', symbol: 'TSh' },
    UA: { code: 'UAH', symbol: '₴' },
    UG: { code: 'UGX', symbol: 'USh' },
    US: { code: 'USD', symbol: '$' },
    UY: { code: 'UYU', symbol: '$U' },
    UZ: { code: 'UZS', symbol: 'soʻm' },
    VN: { code: 'VND', symbol: '₫' },
    YE: { code: 'YER', symbol: 'YR' },
    ZA: { code: 'ZAR', symbol: 'R' },
    ZM: { code: 'ZMW', symbol: 'ZK' }
  };

  function getRealCurrency(countryCode) {
    return COUNTRY_CURRENCY[(countryCode || '').toUpperCase()] || { code: 'USD', symbol: '$' };
  }

  function patchCurrencySpan(span, countryCode) {
    if (!span) return;
    var real = getRealCurrency(countryCode);
    var name = span.textContent.trim().split('(')[0].trim();
    span.textContent = name + '(' + real.code + ' ' + real.symbol + ')';
  }

  document.querySelectorAll(".curreny__selector-options").forEach((selector) => {
    const button = selector.querySelector(".country-button");
    const countryList = selector.querySelector(".country-list");
    const countryInput = selector.querySelector(".selected-country-code");
    const form = selector.querySelector(".country-selector-form");

    // Fix the current button label
    patchCurrencySpan(button.querySelector('.country-currency'), countryInput.value);

    // Fix every item in the list + update data attributes
    selector.querySelectorAll(".country-list li").forEach((item) => {
      var code = item.dataset.value;
      var real = getRealCurrency(code);
      item.dataset.currency = real.code;
      item.dataset.symbol = real.symbol;
      patchCurrencySpan(item.querySelector('.country-currency'), code);
    });

    button.addEventListener("click", function () {
      if (countryList.style.display === "block") {
        countryList.style.display = "none";
        button.classList.remove("active");
      } else {
        countryList.style.display = "block";
        button.classList.add("active");
      }
    });

    selector.querySelectorAll(".country-list li").forEach((item) => {
      item.addEventListener("click", function () {
        const selectedCountry = this.dataset.value;
        const selectedCurrency = this.dataset.currency;
        const selectedSymbol = this.dataset.symbol;
        const flagSrc = this.querySelector(".country-flag").src;
        const countryName = this.querySelector('.country-currency').textContent.trim().split('(')[0].trim();

        button.innerHTML = `
          <img class="country-flag" src="${flagSrc}" alt="Flag">
          <span class="country-currency">
            ${countryName}(${selectedCurrency} ${selectedSymbol})
          </span>
          <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.4997 7.22497C6.36636 7.22497 6.24136 7.20397 6.1247 7.16197C6.00803 7.12064 5.8997 7.04997 5.7997 6.94997L1.1747 2.32497C0.991363 2.14164 0.90403 1.9123 0.912696 1.63697C0.920696 1.3623 1.01636 1.1333 1.1997 0.94997C1.38303 0.766637 1.61636 0.67497 1.8997 0.67497C2.18303 0.67497 2.41636 0.766637 2.5997 0.94997L6.4997 4.84997L10.4247 0.92497C10.608 0.741636 10.8374 0.65397 11.1127 0.66197C11.3874 0.670637 11.6164 0.766637 11.7997 0.94997C11.983 1.1333 12.0747 1.36664 12.0747 1.64997C12.0747 1.9333 11.983 2.16664 11.7997 2.34997L7.1997 6.94997C7.0997 7.04997 6.99136 7.12064 6.8747 7.16197C6.75803 7.20397 6.63303 7.22497 6.4997 7.22497Z" fill="currentColor"/>
          </svg>
        `;

        countryInput.value = selectedCountry;
        countryList.style.display = "none";
        button.classList.remove("active");
        form.submit();
      });
    });

    document.addEventListener("click", function (event) {
      if (!selector.contains(event.target)) {
        countryList.style.display = "none";
        button.classList.remove("active");
      }
    });
  });
});
